export function getMatch2AssetPath(asset: string) {
  const puzzlePath = 'assets/minigame/match2/puzzle/';
  if (asset.startsWith('assets/')) return asset;

  const groupByType: Record<string, string> = {
    block: 'blocks',
    scrap: 'blocks',
    symbol: 'symbols',
    fx: 'effects',
    tile: 'tiles',
  };
  const type = asset.split('/').at(-1)?.split('.')[0] || asset.split('.')[0];
  if (type === 'icon') {
    return getGoalsPath() + asset;
  }

  const group = groupByType[type];
  if (group) {
    return `${puzzlePath}${group}/${asset}`;
  } else {
    return `${puzzlePath}${asset}`;
  }
}

export function getMatch2Frames(
  asset: string,
  args: { last: number; first?: number; pad?: number; ext?: string },
) {
  const { last, first = 0, pad = 3, ext = 'png' } = args;
  const list: string[] = [];
  for (let i = first; i <= last; i++) {
    const index = i.toString().padStart(pad, '0');
    list.push(getMatch2AssetPath(`${asset}.${index}.${ext}`));
  }

  return list;
}

export function getGoalsPath() {
  return 'assets/ui/match2/goals/';
}
